import { useEffect, useState } from 'react';
import { isBrowser } from 'utils/helpers';
import { mixpanel } from 'utils/trackers/mixpanel';

const EVA_ENTRY_FLAG = 'eva_search_v_1';
const EVA_ENTRY_CONTROL = 'control';
const EVA_ENTRY_VARIANT = 'variant';
const EVA_ENTRY_TREATMENT = 'treatment';
const IS_DEV = process.env.NODE_ENV === 'development';

export type EvaEntryVariant = 'eva-modal' | 'elevenlabs-widget';
type EvaExperimentValue = string | boolean | null | undefined;

const resolveVariant = (value: EvaExperimentValue): EvaEntryVariant => {
  if (value === true) return 'eva-modal';
  if (value === EVA_ENTRY_VARIANT || value === EVA_ENTRY_TREATMENT) {
    return 'eva-modal';
  }
  if (value === 'true' || value === 'on') return 'eva-modal';
  return 'elevenlabs-widget';
};

const useEvaEntryExperiment = () => {
  const [isReady, setIsReady] = useState(false);
  const [variant, setVariant] =
    useState<EvaEntryVariant>('elevenlabs-widget');

  useEffect(() => {
    if (!isBrowser()) return;
    let isMounted = true;

    const fetchVariant = async () => {
      if (IS_DEV) {
        if (!isMounted) return;
        setVariant('eva-modal');
        setIsReady(true);
        return;
      }

      const value = await mixpanel.getVariantValue(
        EVA_ENTRY_FLAG,
        EVA_ENTRY_CONTROL,
      );

      if (!isMounted) return;
      setVariant(resolveVariant(value as EvaExperimentValue));
      setIsReady(true);
    };

    fetchVariant();

    return () => {
      isMounted = false;
    };
  }, []);

  return {
    isReady,
    variant,
    isEvaModalVariant: variant === 'eva-modal',
    isWidgetVariant: variant === 'elevenlabs-widget',
  };
};

export default useEvaEntryExperiment;
